import { ethers } from 'ethers';
import { AroundUIHelperContract } from '../contracts/AroundUIHelper';
import { getAddresses } from './address';

export async function loadMarketBasics(provider, uiAddr, marketIdBn) {
  const ui = new AroundUIHelperContract(uiAddr, provider);
  const data = await ui.indexMarketData(marketIdBn);
  const mi = data?.thisMarketInfo ?? data?.[2];

  // Handle thisMarketInfo array format
  let marketInfo = mi;
  if (Array.isArray(mi)) {
    marketInfo = {
      result: mi[0],
      ifOpenAave: mi[1],
      ifUpdateFinallyAmount: mi[2],
      participants: mi[3],
      startTime: mi[4],
      endTime: mi[5],
      collateral: mi[6],
      totalRaffleTicket: mi[7]
    };
  }

  const li = data?.thisLiqudityInfo ?? data?.[3];
  console.log('%c🚀[li]-10:', 'color: #5f30ba', li);
  const fi = data?.thisFeeInfo ?? data?.[1];
  console.log('%c🚀[fi]-11:', 'color: #3903c3', fi);
  const pool = data?.thisPoolInfo ?? data?.[0];
  const ZERO = '0x0000000000000000000000000000000000000000';
  let collateral = (pool?.collateral ?? marketInfo?.collateral ?? pool?.[1] ?? '') || '';
  if (!collateral || collateral === ZERO) collateral = getAddresses()?.USDC || '';
  const d = await ui.getDecimals(collateral);
  const decimals = Number(d) || 6;
  const yp = await ui.getYesPrice(marketIdBn).catch(() => 0n);
  const np = await ui.getNoPrice(marketIdBn).catch(() => 0n);
  const yesPrice = parseFloat(Number(ethers.formatUnits(yp, 18)).toFixed(4));
  const noPrice = parseFloat(Number(ethers.formatUnits(np, 18)).toFixed(4));
  const volume = Number(ethers.formatUnits((li?.tradeCollateralAmount ?? li?.[2] ?? 0n), decimals));
  const liquidity = {
    virtual: Number(ethers.formatUnits((li?.virtualLiquidity ?? li?.[0] ?? 0n), decimals)),
    real:
      Number(ethers.formatUnits((li?.tradeCollateralAmount ?? li?.[2] ?? 0n), decimals)) +
      Number(ethers.formatUnits((li?.lpCollateralAmount ?? li?.[1] ?? 0n), decimals)),
    fee: Number(ethers.formatUnits((li?.liquidityFeeAmount ?? li?.[5] ?? 0n), decimals)),
  };
  const denom = ethers.toBigInt(fi?.liquidityFee ?? fi?.[0] ?? 0);
  const base = (li?.liquidityFeeAmount ?? li?.[5] ?? 0n);
  const calc = (num) => (denom > 0n ? (base * ethers.toBigInt(num || 0)) / denom : 0n);
  const fees = {
    liquidityFee: Number(ethers.formatUnits(base, decimals)),
    luckyFee: Number(ethers.formatUnits(calc(fi?.luckyFee ?? fi?.[1]), decimals)),
    creatorFee: Number(ethers.formatUnits(calc(fi?.creatorFee ?? fi?.[2]), decimals)),
    oracleFee: Number(ethers.formatUnits(calc(fi?.oracleFee ?? fi?.[3]), decimals)),
    officialFee: Number(ethers.formatUnits(calc(fi?.officialFee ?? fi?.[4]), decimals)),
  };

  // Map result to resolution string
  const resolution = marketInfo?.result === 1 ? 'yes' : marketInfo?.result === 2 ? 'no' : 'pending';

  const mapped = {
    id: marketIdBn.toString(),
    title: (pool?.quest || '').toString(),
    category: Number.isFinite(Number(marketInfo?.marketType)) ? Number(marketInfo.marketType) : 0,
    participants: Number(marketInfo?.participants || 0),
    endDate: marketInfo?.endTime ? new Date(Number(marketInfo.endTime) * 1000) : null,
    raffleTickets: Number(marketInfo?.totalRaffleTicket || 0),
    volume,
    liquidity,
    resolution,
    ifOpenAave: Boolean(marketInfo?.ifOpenAave ?? false),
    ifUpdateFinallyAmount: Boolean(marketInfo?.ifUpdateFinallyAmount ?? false),
  };
  return { collateral, decimals, yesPrice, noPrice, mapped, fees };
}

export function parseUserPosition(pos, decimals) {
  const raffle = Number((pos?.raffleTicketNumber ?? pos?.[0] ?? 0) || 0);
  const collWei = (pos?.collateralAmount ?? pos?.[1] ?? 0n);
  const yesWei = (pos?.yesBalance ?? pos?.[2] ?? 0n);
  const noWei = (pos?.noBalance ?? pos?.[3] ?? 0n);
  const lpWei = (pos?.lp ?? pos?.[4] ?? 0n);
  const volWei = (pos?.volume ?? pos?.[5] ?? 0n);
  return {
    yes: Number(ethers.formatUnits(yesWei, decimals)),
    no: Number(ethers.formatUnits(noWei, decimals)),
    collateral: Number(ethers.formatUnits(collWei, decimals || 6)),
    volume: Number(ethers.formatUnits(volWei, decimals || 6)),
    lp: Number(ethers.formatUnits(lpWei, decimals)),
    lpRaw: lpWei,
    raffle,
  };
}
